import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LegalNotice = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-sm p-8">
        <Link to="/" className="inline-flex items-center text-blue-600 hover:text-blue-700 mb-6">
          <ArrowLeft className="h-4 w-4 mr-2" />
          Volver a inicio
        </Link>
        
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Aviso Legal</h1>
        
        <div className="prose prose-gray max-w-none space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">1. Datos Identificativos</h2>
            <p className="text-gray-600">
              En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y Comercio Electrónico, se informa:
            </p>
            <p className="text-gray-600 mt-3">
              <strong>Denominación social:</strong> Eye Star S.L.<br />
              <strong>CIF:</strong> B87171740<br />
              <strong>Domicilio:</strong> Avenida de la Industria 16, Tres Cantos (Madrid)<br />
              <strong>Email:</strong> reservas@hotel-martorell.es<br />
              <strong>Actividad:</strong> Servicios hoteleros y alojamiento turístico
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">2. Objeto</h2>
            <p className="text-gray-600">
              El presente sitio web tiene por objeto facilitar al público información sobre los servicios y actividades de Eye Star S.L., propietaria de los establecimientos Hotel Ciutat Martorell, Port Sitges Hotel y Hostal San Francisco.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">3. Propiedad Intelectual e Industrial</h2>
            <p className="text-gray-600">
              Todos los contenidos del sitio web (textos, fotografías, gráficos, imágenes, iconos, software, etc.) son propiedad intelectual de Eye Star S.L. o de terceros que han autorizado su uso. Queda prohibida su reproducción, distribución, comunicación pública y transformación sin autorización expresa.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">4. Condiciones de Uso</h2>
            <p className="text-gray-600">
              El usuario se compromete a hacer un uso adecuado de los contenidos y servicios ofrecidos a través de este sitio web, absteniéndose de:
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2 mt-2">
              <li>Realizar actividades ilícitas o contrarias a la buena fe.</li>
              <li>Difundir contenidos de carácter racista, xenófobo, pornográfico o que atenten contra los derechos humanos.</li>
              <li>Introducir virus informáticos o realizar actuaciones susceptibles de alterar, estropear o dañar los sistemas informáticos.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">5. Exclusión de Responsabilidad</h2>
            <p className="text-gray-600">
              Eye Star S.L. no se hace responsable de los daños o perjuicios que pudieran derivarse del uso de este sitio web, incluyendo:
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2 mt-2">
              <li>Errores u omisiones en los contenidos.</li>
              <li>Falta de disponibilidad del sitio web.</li>
              <li>Transmisión de virus o programas maliciosos.</li>
              <li>Uso indebido por parte de terceros.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">6. Enlaces</h2>
            <p className="text-gray-600">
              Este sitio web puede contener enlaces a páginas de terceros. Eye Star S.L. no asume ninguna responsabilidad por el contenido, información o servicios que pudieran aparecer en dichos sitios enlazados.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">7. Legislación Aplicable y Jurisdicción</h2>
            <p className="text-gray-600">
              Las presentes condiciones se rigen por la legislación española. Para cualquier controversia que pudiera derivarse del acceso o uso de este sitio web, las partes se someten a los Juzgados y Tribunales de Madrid.
            </p>
          </section>
        </div>

        <p className="text-sm text-gray-500 mt-8">
          Última actualización: Febrero 2026
        </p>
      </div>
    </div>
  );
};

export default LegalNotice;
